import {PAGES} from "../../../../core/consts";
import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {CompetitorStandingsPageRouteConfig} from "./models/competitor.standings-page.route.config";

export class CompetitorStandingsPageConfig extends BaseConfig {
  static injectables = [CompetitorStandingsPageRouteConfig];

  constructor(route: CompetitorStandingsPageRouteConfig) {
    super(PAGES.COMPETITOR.standings, route);
  }
}
